// Generated by azure-function/scripts/sync-cis-safeguards.mjs. Do not edit by hand.
// Official name and implementation group (IG1-3) of each CIS Controls v8 safeguard NordComply cites.
export const CIS_SAFEGUARDS = {
  "2.5": {
    "name": "Allowlist Authorized Software",
    "ig": 2
  },
  "3.3": {
    "name": "Configure Data Access Control Lists",
    "ig": 1
  },
  "3.6": {
    "name": "Encrypt Data on End-User Devices",
    "ig": 1
  },
  "3.7": {
    "name": "Establish and Maintain a Data Classification Scheme",
    "ig": 2
  },
  "3.9": {
    "name": "Encrypt Data on Removable Media",
    "ig": 2
  },
  "3.13": {
    "name": "Deploy a Data Loss Prevention Solution",
    "ig": 3
  },
  "4.1": {
    "name": "Establish and Maintain a Secure Configuration Process",
    "ig": 1
  },
  "4.2": {
    "name": "Establish and Maintain a Secure Configuration Process for Network Infrastructure",
    "ig": 1
  },
  "4.3": {
    "name": "Configure Automatic Session Locking on Enterprise Assets",
    "ig": 1
  },
  "4.5": {
    "name": "Implement and Manage a Firewall on End-User Devices",
    "ig": 1
  },
  "4.7": {
    "name": "Manage Default Accounts on Enterprise Assets and Software",
    "ig": 1
  },
  "4.8": {
    "name": "Uninstall or Disable Unnecessary Services on Enterprise Assets and Software",
    "ig": 2
  },
  "4.10": {
    "name": "Enforce Automatic Device Lockout on Portable End-User Devices",
    "ig": 2
  },
  "4.12": {
    "name": "Separate Enterprise Workspaces on Mobile End-User Devices",
    "ig": 3
  },
  "5.2": {
    "name": "Use Unique Passwords",
    "ig": 1
  },
  "5.3": {
    "name": "Disable Dormant Accounts",
    "ig": 1
  },
  "5.4": {
    "name": "Restrict Administrator Privileges to Dedicated Administrator Accounts",
    "ig": 1
  },
  "6.1": {
    "name": "Establish an Access Granting Process",
    "ig": 1
  },
  "6.3": {
    "name": "Require MFA for Externally-Exposed Applications",
    "ig": 1
  },
  "6.4": {
    "name": "Require MFA for Remote Network Access",
    "ig": 1
  },
  "6.5": {
    "name": "Require MFA for Administrative Access",
    "ig": 1
  },
  "6.7": {
    "name": "Centralize Access Control",
    "ig": 2
  },
  "6.8": {
    "name": "Define and Maintain Role-Based Access Control",
    "ig": 3
  },
  "7.3": {
    "name": "Perform Automated Operating System Patch Management",
    "ig": 1
  },
  "8.2": {
    "name": "Collect Audit Logs",
    "ig": 1
  },
  "8.5": {
    "name": "Collect Detailed Audit Logs",
    "ig": 2
  },
  "8.11": {
    "name": "Conduct Audit Log Reviews",
    "ig": 2
  },
  "9.3": {
    "name": "Maintain and Enforce Network-Based URL Filters",
    "ig": 2
  },
  "9.4": {
    "name": "Restrict Unnecessary or Unauthorized Browser and Email Client Extensions",
    "ig": 2
  },
  "9.5": {
    "name": "Implement DMARC",
    "ig": 2
  },
  "9.6": {
    "name": "Block Unnecessary File Types",
    "ig": 2
  },
  "9.7": {
    "name": "Deploy and Maintain Email Server Anti-Malware Protections",
    "ig": 3
  },
  "10.1": {
    "name": "Deploy and Maintain Anti-Malware Software",
    "ig": 1
  },
  "11.2": {
    "name": "Perform Automated Backups",
    "ig": 1
  },
  "12.2": {
    "name": "Establish and Maintain a Secure Network Architecture",
    "ig": 2
  },
  "12.6": {
    "name": "Use of Secure Network Management and Communication Protocols",
    "ig": 2
  },
  "13.1": {
    "name": "Centralize Security Event Alerting",
    "ig": 2
  },
  "13.2": {
    "name": "Deploy a Host-Based Intrusion Detection Solution",
    "ig": 2
  },
  "13.5": {
    "name": "Manage Access Control for Remote Assets",
    "ig": 2
  },
  "14.2": {
    "name": "Train Workforce Members to Recognize Social Engineering Attacks",
    "ig": 1
  },
  "17.3": {
    "name": "Establish and Maintain an Enterprise Process for Reporting Incidents",
    "ig": 1
  }
};
